import { computed, onUnmounted, ref, watch } from 'vue';

export const useHeaderMenu = () => {
    const isMenuOpen = ref(false);

    const menuClasses = computed(() => ({
        'header__menu--is-opened': isMenuOpen.value,
    }));

    let initialBodyOverflow = '';
    let initialBodyPaddingRight = '';

    const getScrollbarWidth = () => {
        return window.innerWidth - document.documentElement.clientWidth;
    };

    const lockBodyScroll = () => {
        const scrollbarWidth = getScrollbarWidth();

        initialBodyOverflow = document.body.style.overflow;
        initialBodyPaddingRight = document.body.style.paddingRight;

        document.body.style.overflow = 'hidden';

        if (scrollbarWidth > 0) {
            document.body.style.paddingRight = `${scrollbarWidth}px`;
        }
    };

    const unlockBodyScroll = () => {
        document.body.style.overflow = initialBodyOverflow;
        document.body.style.paddingRight = initialBodyPaddingRight;
    };

    const closeMenu = () => {
        isMenuOpen.value = false;
    };

    watch(isMenuOpen, (isOpened) => {
        if (isOpened) {
            lockBodyScroll();
            return;
        }

        unlockBodyScroll();
    });

    onUnmounted(() => {
        unlockBodyScroll();
    });

    return {
        isMenuOpen,
        menuClasses,
        closeMenu,
    };
};
